
export default {
  ACCESS_TOKEN_CHECK_TIMEOUT: 'ACCESS_TOKEN_CHECK_TIMEOUT',
  ACCESS_TOKEN_REQUEST: "ACCESS_TOKEN_REQUEST",
  ACCESS_TOKEN_RECEIVE: "ACCESS_TOKEN_RECEIVE",
  ACCESS_TOKEN_FAILURE: "ACCESS_TOKEN_FAILURE",
  ACCESS_TOKEN_INITIAL: "ACCESS_TOKEN_INITIAL",
  ACCESS_TOKEN_CHECK: 'ACCESS_TOKEN_CHECK',
}